export const USER_DISPLAY_STRINGS_RFX = {
  title: 'SMART',
  breadcrumbs: {
    home: 'Home',
    dashboard: 'Dashboard',
    createrequest: 'Create Request',
    editround: 'Edit Round',
    initiateround: 'Initiate Round',
    editresponse: 'Edit Bid',
    initiateResponse: 'Initiate Bid'
  },
  leftNavigation: {
    smart: {
      title: 'SMART',
      rfq: {
        title: 'RFQ',
        dashboard: 'Dashboard',
        buyerdashboard: 'Buyer Dashboard',
        supplierdashboard: 'Supplier Dashboard'
      },
      rfi: {
        title: 'RFI',
        dashboard: 'Dashboard',
        buyerdashboard: 'Buyer Dashboard',
        supplierdashboard: 'Supplier Dashboard'
      },
      changeOrder: {
        title: 'Change Order',
        dashboard: 'Change Orders'
      },
      notifications: 'Notifications',
    }
  },
  pages: {
    dashboard: {
      title: 'RFX Dashboard'
    },
    createrequest: {
      title: 'Create Request'
    },
    clonerequest: {
      title: 'Clone Request'
    },
    editround: {
      title: 'Edit Round'
    },
    initiateround: {
      title: 'Initiate Round'
    },
    editresponse: {
      title: 'Edit Bid'
    },
    initiateresponse: {
      title: 'Initiate Bid'
    },
    postaward: {
      title: 'Post Award'
    },
    createrfi: {
      title: 'Create New RFI'
    },
    clonerfi: {
      title: 'Clone RFI Request'
    },
    editrfi: {
      title: 'Edit RFI Request'
    }
  },
  tablePreference: {
    title: 'Preferences',
    confirmLabel: 'Confirm',
    cancelLabel: 'Cancel',
    pageSizeSelectorTitle: 'Page size'
  },
  pageSizeOption: {
    tenItems: '10 items',
    twentyFiveItems: '25 items',
    fiftyItems: '50 items',
    oneHundredItems: '100 items'
  },
  quoteStep: {
    downloadErrorReport: 'Download the error report to address the validation errors and try again.'
  }
};

export default USER_DISPLAY_STRINGS_RFX;
